import styled from 'styled-components'
import { themeColor } from 'LibNeo'

export const RequiredHighlightText = styled.div`
	font-size: 12px;
	line-height: 20px;
	color: ${themeColor('gold', 5)};
`
